'use es6';

import { invalidateCache } from '../utils/ActionUtils';
export default (() => next => action => {
  if (action.meta && action.meta.invalidateCache) {
    invalidateCache();
  }

  return next(action);
});